import SearchComponent from '../base/search-component.ts';
import type { LavoratoreCompleto } from '@/types/entities/ricerca.ts';
import { getCasseMap } from '../lib/casse-info.ts';
import { withCessatoInfo } from '../lib/cessato-info.ts';

interface RisultatoRicerca {
  risultati: LavoratoreCompleto[];
  count: number;
}

export class RicercaLavoratori extends SearchComponent<RisultatoRicerca> {
  static override componentName = 'wc-ricerca-lavoratori';

  protected override get templateId() { return 'ricerca-lavoratori'; }
  protected override get resultsTemplateId() { return 'shared-lavoratori-risultati'; }

  protected override fetchResults(query: string) {
    return this.api.lavoratori.cerca(query);
  }

  protected override mapResultsData(data: RisultatoRicerca) {
    return {
      lavoratori: withCessatoInfo(data.risultati),
      casse: Object.values(getCasseMap()),
      count: data.count,
      action: 'dettaglio',
    };
  }

  protected override onReady(): void {
    const basePath = this.attributeString('detail-path', '/lavoratori');

    this.delegate.on<MouseEvent>('click', '[data-action="dettaglio"]', (e) => {
      const id = (e.target as HTMLElement).dataset.id;
      if (id) window.location.href = `${basePath}/${id}`;
    });
  }
}
